import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navigation.module.css';
import Button from '../UI/Button';

const Navigation = () => {
    const location = useLocation();

    const navItems = [
        { path: '/', label: 'Home' },
        { path: '/services', label: 'Services' },
        { path: '/about', label: 'About' },
        { path: '/contact', label: 'Contact' },
    ];

    return (
        <nav className={styles.navContainer}>
            <ul className={styles.navList}>
                {navItems.map((item) => (
                <li key={item.path}>
                    <Link
                    to={item.path}
                    className={`${styles.navLink} ${
                        location.pathname === item.path ? styles.active : ''
                    }`}
                    >
                        {item.label}
                    </Link>
                </li>
                ))}
            </ul>
            <div className={styles.navCta}>
                <Button
                as={Link}
                to="/contact"
                variant="primary"
                size="medium"
                className={styles.ctaButton}
                >
                    Get Started
                </Button>
            </div>
        </nav>
    );
};

export default Navigation;